import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { get } from 'lodash';
import {
	SdfBox,
	SdfButton,
	SdfDatePicker,
	SdfIcon,
	SdfSpotIllustration,
} from '@synerg/react-components';
import { getFormattedStringDate, getFormattedCutOffDate, adjustTimezone } from './../../../common';

export const LinkAndCutOff = (props = {}) => {
	const {
		selectedEnvironment,
		activeChangeRequest = false,
		projectDetails,
		startAPICall,
		setLoading,
		setError,
		setShowToast,
		setInfoMessage,
		carDetails
	} = props;
	const consentURL = projectDetails.consentURLPendingEmail;

	const [cutOffDate, setCutOffDate] = useState();
	const [cutOffDateButtonDisabled, setCutOffDateButtonDisabled] = useState(true);

	const subscriptions = selectedEnvironment === "PROD"
		? get(carDetails, 'prod.subscriptions', [])
		: get(carDetails, 'subscriptions', []);

	const preAuthRequiredCount = get(subscriptions, 'preAuth.preAuthRequiredCount', 0);

	const updateCutOffDate = async () => {
		startAPICall();
		try {
			const { data: { success = false } } = await axios.put(`${import.meta.env.VITE_ROOT_PATH}/api/project/change-request/${activeChangeRequest._id}`, {
				cutOffDate: getFormattedCutOffDate(cutOffDate)
			});

			if (success) {
				setInfoMessage('Cutoff date has been updated successfully.');
				setCutOffDateButtonDisabled(true);
			} else {
				setError(true);
				setInfoMessage('We are sorry about the inconvenience. Please try again.');
			}
		} catch (e) {
			setError(true);
			setInfoMessage('We are sorry about the inconvenience. Please try again.');
		} finally {
			setShowToast(true);
			setLoading(false);
		}
	};

	useEffect(() => {
		setCutOffDate(getFormattedStringDate(adjustTimezone(activeChangeRequest.cutOffDate)));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeChangeRequest]);

	return (
		<div className="w-full">
			<div className={"flex justify-between gap-6 mt-6 pb-4"}>
				{consentURL && (
					<SdfBox variant="bordered" className="p-5 flex w-full">
						<div className="flex w-full gap-5 items-center">
							<div className="text-center">
								<SdfSpotIllustration illustration-name="email" />
							</div>
							<div className="flex-1 break-all">
								<div className="text-heading-04 font-bold">
									Need to resend a client auth link?
								</div>
								<div className="text-body-01">{consentURL}</div>
							</div>
							<div className="text-center">
								<SdfButton
									className="font-medium"
									variant={"text"}
									onClick={() => navigator.clipboard.writeText(consentURL)}
								>
									Copy link
								</SdfButton>
							</div>
						</div>
					</SdfBox>
				)}

				{activeChangeRequest && selectedEnvironment === "PROD" && (
					<SdfBox variant="bordered" className="p-4 min-w-2/5">
						<div className="w-full">
							<div className="w-full inline-flex" style={{ color: "#983f00" }}>
								<SdfIcon icon={"status-flagged"} className="pr-2" />
								<div className="text-body-02">
									{`${preAuthRequiredCount} customer${preAuthRequiredCount > 1 ? 's' : ''} require${preAuthRequiredCount > 1 ? '' : 's'} pre-authorization`}
								</div>
							</div>
							<div className="w-full mt-3">
								<SdfDatePicker
									className="w-full"
									label="Cutoff date"
									rules={[{
										type: "DISABLED",
										startDateInclusive: new Date(0, 0, 0),
										endDateInclusive: new Date().setDate(new Date().getDate() - 1)
									}]}
									placeholder="MM/DD/YYYY"
									value={cutOffDate}
									onSdfChange={({ detail }) => {
										setCutOffDate(detail);
										setCutOffDateButtonDisabled(getFormattedStringDate(adjustTimezone(activeChangeRequest.cutOffDate))
											=== getFormattedStringDate(detail) ? true : undefined);
									}}
								/>
							</div>
							<div className="w-full mt-2">
								<SdfButton
									className="font-medium"
									variant={"text"}
									onClick={() => updateCutOffDate()}
									disabled={cutOffDateButtonDisabled}
								>
									Update
								</SdfButton>
							</div>
						</div>
					</SdfBox>
				)}
			</div>
		</div>
	);
};
